const url = "/aio/kosik-doplnky";
document.addEventListener('DOMContentLoaded', loadCarousel);

function loadCarousel() {
	const cartAccsContainer = document.getElementById('cart-accs-container');

	// Check if element exists before proceeding
	if (!cartAccsContainer) {
		console.log('cart-accs-container element not found');
		return;
	}

	fetch(url)
		.then(function (response) {
			if (response.ok) {
				return response.text();
			} else {
				console.log(response.statusText);
			}
		})
		.then(function (html) {
			cartAccsContainer.innerHTML = html;
		})
		.then(function () {
			startCarousel();
		})
		.catch(function (error) {
			console.log(error);
		});
}

function startCarousel() {
	const carousel = new Swiper('.cart-carousel', {
		direction: 'horizontal',
		loop: true,
		centeredSlides: true,
		centeredSlidesBounds: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: true,
		},
		slidesPerView: 1,
		spaceBetween: 10,
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 2
			},
			// when window width is >= 480px
			480: {
				slidesPerView: 3
			},
			// when window width is >= 640px
			640: {
				slidesPerView: 4
			}
		},
		// And if we need scrollbar
		scrollbar: {
			el: '.swiper-scrollbar',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}